import React from 'react';
import {observer} from 'mobx-react';

export const Dots = observer(({competitor, isSmallView}) => {
  const dots = [];
  const {fouls} = competitor;

  for (let i = 0; i < fouls?.total; i++) {
    const dot = {
      key: i,
      className: ['dot', (fouls?.current > i ? 'dot-active' : ''), isSmallView ? 'dot-small-view' : ''].join(' ')
    };

    dots.push(dot);
  }

  return (
    <div className={'dots-container'}>
      {
        dots.map((dot) => <div {...dot}/>)
      }
    </div>
  )
});
